import { Sravnenie16, SravnenieAdd16 } from '@cian/ui-kit';
import cs from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IComparisonControlProps {
  added: boolean;
  disabled: boolean;
  onClick(): void;
}

export function ComparisonControl({ added, disabled, onClick }: IComparisonControlProps) {
  return (
    <div>
      <button onClick={onClick} disabled={disabled} className={cs(styles['button'], disabled && styles['disabled'])}>
        {added ? (
          <SravnenieAdd16 color="primary_100" />
        ) : (
          <Sravnenie16 color={disabled ? 'gray60_100' : 'primary_100'} />
        )}
      </button>
    </div>
  );
}
